var __jsx = React.createElement;
import { cn } from "@lib/cn";
import { BREAKPOINTS } from "@lib/constants";
import useMoneyDisplay from "@lib/hooks/use-money-display";
import React from "react";
import { useMediaQuery } from "react-responsive";
const CalendarFooterPriceItem = _ref => {
  let {
    price,
    color,
    minWidthFit
  } = _ref;
  const formattedPrice = useMoneyDisplay(price);
  return __jsx("span", {
    className: cn("flex text-neutral_black flex-row flex-1 text-center py-2 px-3 rounded-md text-sm items-center justify-center", color, {
      "min-w-fit": minWidthFit
    })
  }, formattedPrice, "+");
};
const CalendarPricesFooter = _ref2 => {
  let {
    lowestFrom,
    mediumFrom,
    highestFrom,
    minWidthFitIfCan
  } = _ref2;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const colors = ["bg-calendar-low", "bg-calendar-medium", "bg-calendar-high"];
  return __jsx("div", {
    className: cn("flex flex-row gap-2", {
      "w-full": isMobile
    })
  }, [lowestFrom, mediumFrom, highestFrom].map((price, index) => __jsx(CalendarFooterPriceItem, {
    key: index,
    price: price,
    color: colors[index],
    minWidthFit: minWidthFitIfCan !== null && minWidthFitIfCan !== void 0 ? minWidthFitIfCan : false
  })));
};
export default CalendarPricesFooter;